export class CloseCyberEventCompromisedSourcingCompanyRequest {
    constructor(ids: string[]) {
        this.ids = ids;
    }
    ids: string[];
}